/* unplugin-vue-components disabled */import { render } from "./OrderedAnswerButtonGroup.vue?vue&type=template&id=c5ace128&scoped=true"
import script from "./OrderedAnswerButtonGroup.vue?vue&type=script&lang=js"
export * from "./OrderedAnswerButtonGroup.vue?vue&type=script&lang=js"

import "./OrderedAnswerButtonGroup.vue?vue&type=style&index=0&id=c5ace128&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ace128"]])

export default __exports__